<template>
  <v-card-round>
    <v-container>
      <!-- Title -->
      <v-layout justify-center>
        <v-flex class="display-1 font-weight-light blue-grey--text" shrink>Login</v-flex>
      </v-layout>
      <!-- Email -->
      <v-layout>
        <v-flex>
          <v-text-field
            v-model="email"
            autofocus
            :error="emailError"
            hint="Ocupa el mismo email de tu cuenta QMatch"
            @keyup.enter="validateAndAuthenticate"
            label="Email"
            prepend-icon="email"
            type="email"
          />
        </v-flex>
      </v-layout>
      <!-- Password -->
      <v-layout>
        <v-flex>
          <v-text-field
            v-model="password"
            :error="passwordError"
            @keyup.enter="validateAndAuthenticate"
            label="Contraseña"
            prepend-icon="vpn_key"
            type="password"
          />
        </v-flex>
      </v-layout>
      <!-- Confirmation button -->
      <v-layout justify-center>
        <v-flex shrink>
          <v-btn
            @click="validateAndAuthenticate"
            color="purple"
            dark
            :loading="loadingAuthentication"
            round
          >
            <span class="mr-2">Ingresar</span>
            <v-icon>send</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-round>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers("auth");

import VCardRound from "@/components/cards/CardRound";

export default {
  components: {
    VCardRound
  },
  data: () => ({
    email: null,
    emailError: false,
    password: null,
    passwordError: false
  }),
  computed: {
    ...mapState(["loadingAuthentication"])
  },
  methods: {
    ...mapActions(["authenticate"]),
    validateAndAuthenticate() {
      this.emailError = !this.email;
      this.passwordError = !this.password;

      if (this.emailError || this.passwordError) return;

      return this.authenticate({
        email: this.email,
        password: this.password
      })
        .then(() =>
          this.$router.push({ name: this.$route.query.next || "home" })
        )
        .catch(err => {
          if (err.response.status === 400) {
            return this.$notify.error("Email y contraseña no coinciden");
          }

          this.$$notify.error(
            "Al parecer tuvimos un problema con la autenticación"
          );
        });
    }
  }
};
</script>